import createClient from "../../helpers/api-client";

const storeSuffix = "Company";

// Actions
export const FETCH_COMPANY_BY_ID = `fetchCompanyByIdAction${storeSuffix}`;
export const FETCH_COMPANY_BY_SLUG = `fetchCompanyBySlugAction${storeSuffix}`;

// Mutations
export const BEGIN_FETCH_COMPANY = `beginFetchCompanyMutation${storeSuffix}`;
export const RECEIVED_COMPANY = `receivedCompanyMutation${storeSuffix}`;
export const COMPANY_NOT_FOUND = `companyNotFoundMutation${storeSuffix}`;

// Getters
export const GET_COMPANY = `getCompanyGetter${storeSuffix}`;
export const IS_LOADING = `getIsLoadingGetter${storeSuffix}`;
export const GET_ERROR = `getErrorGetter${storeSuffix}`;

export const modelState = () => ({
    company: {
        isLoading: true,
        error: null,
        data: []
    }
});

export const actions = {
    [FETCH_COMPANY_BY_ID]: ({ state, commit }, id) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);
            commit(BEGIN_FETCH_COMPANY);

            try {
                const res = await apiClient.get(`/api/company/${id}`);

                commit(RECEIVED_COMPANY, res);
                resolve(res);
            } catch (error) {
                commit(COMPANY_NOT_FOUND, {
                    error
                });
                resolve(error);
            }
        });
    },
    [FETCH_COMPANY_BY_SLUG]: ({ state, commit }, slug) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);
            commit(BEGIN_FETCH_COMPANY);

            try {
                const res = await apiClient.get(`/api/company/name/${slug}`);

                commit(RECEIVED_COMPANY, res);
                resolve(res);
            } catch (error) {
                commit(COMPANY_NOT_FOUND, {
                    error
                });
                resolve(error);
            }
        });
    }
};

export const mutations = {
    [BEGIN_FETCH_COMPANY]: state => {
        state.company.isLoading = true;
        state.company.error = null;
        state.company.data = [];
    },
    [RECEIVED_COMPANY]: (state, payload) => {
        const { data } = payload;
        state.company.isLoading = false;
        state.company.error = null;
        state.company.data = data;
    },
    [COMPANY_NOT_FOUND]: (state, { error }) => {
        state.company.isLoading = false;
        state.company.error = error;
    }
};

export const getters = {
    [GET_COMPANY]: state => {
        return state.company.data;
    },
    [IS_LOADING]: state => {
        return state.company.isLoading;
    },
    [GET_ERROR]: state => {
        return state.company.error;
    }
};



// WEBPACK FOOTER //
// ./src/store/store-models/company-model.js